import React from 'react';
import { BrowserRouter as Router, Switch, Route  } from "react-router-dom";
import Home from './components/Home'
import About from "./components/About";
import Expertise from "./components/Expertise";
import Lawyers from "./components/Lawyers";
import Contact from "./components/Contact";
import NavBar from './components/NavBar'
import Footer from './components/Footer';

function App() { 
  return (
     <Router>
     <div>
      <NavBar />

        
        <Switch>
          <Route path="/about"><About /></Route>
          <Route path="/expertise"><Expertise /></Route>
          <Route path="/lawyers"><Lawyers /></Route>
          <Route path="/contact"><Contact /></Route>
          <Route path="/organisation"><About /></Route>
          <Route path="/clientele"><About /></Route>
          <Route path="/commercial-law"><Expertise /></Route>
          <Route path="/construction"><Expertise /></Route>
          <Route path="/corporate"><Expertise /></Route>
          <Route path="/corporate-finance"><Expertise /></Route>
          <Route path="/criminal"><Expertise /></Route>
          <Route path="/dispute-resolution"><Expertise /></Route>
          <Route path="/employment"><Expertise /></Route>
          <Route path="/environmental"><Expertise /></Route>
          <Route path="/family"><Expertise /></Route>
          <Route path="/insurance-and-reinsurance"><Expertise /></Route>
          <Route path="/intellectual-property"><Expertise /></Route>
          <Route path="/litigation"><Expertise /></Route>
          <Route path="/media"><Expertise /></Route>
          <Route path="/personal-injury"><Expertise /></Route>
          <Route path="/private-client"><Expertise /></Route>
          <Route path="/private-equity"><Expertise /></Route>
          <Route path="/company-formation"><Expertise /></Route>
          <Route path="/property-law"><Expertise /></Route>
          <Route path="/mohamed-nabeel-saeed"><Lawyers /></Route>
          <Route path="/"><Home /></Route>
        </Switch>

  {/* <div id="ftco-loader" className="show fullscreen"><svg className="circular" width="48px" height="48px"><circle className="path-bg" cx="24" cy="24" r="22" fill="none" stroke-width="4" stroke="#eeeeee"/><circle className="path" cx="24" cy="24" r="22" fill="none" stroke-width="4" stroke-miterlimit="10" stroke="#F96D00"/></svg></div> */}
        <Footer/>
    </div>
      </Router>
  );
}

export default App;
